import { useState, useEffect } from 'react';
import isomorphicFetch from 'isomorphic-fetch';

// 全局缓存
let PROVINCE_DATA: any[] = [];

export function useProvinceData() {
  const [provinceData, setProvinceData] = useState<any[]>(PROVINCE_DATA);

  useEffect(() => {
    if (PROVINCE_DATA.length > 0) {
      setProvinceData(PROVINCE_DATA);
      return;
    }

    const fetchData = async () => {
      try {
        const response = await isomorphicFetch('https://static.za-doctor.com/common/province/area.json?t=' + Date.now());
        if (response.ok) {
          const data = await response.json();
          PROVINCE_DATA = data;
          setProvinceData(data);
        }
      } catch (error) {
        console.error('获取省市区数据失败:', error);
      }
    };

    fetchData();
  }, []);

  return provinceData;
}